import { render, staticRenderFns } from "./drag-drawer.vue?vue&type=template&id=30135eaa&"
import script from "./drag-drawer.vue?vue&type=script&lang=js&"
export * from "./drag-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports